export const blurOnEnter = (): { onKeyDown: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement> } => ({
  onKeyDown: (e) => e.key === 'Enter' && e.currentTarget.blur()
});
